import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiFabSpeakTextController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiFabSpeakTextController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiFabSpeakText` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiFabSpeakText
 *
 */
export class VanillaReaderUiFabSpeakTextController {
    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext: vanillaReaderUiContext.fabSpeakText.onClick(vanillaReaderUiContext._onFabSpeakTextClicked.bind(vanillaReaderUiContext));
    }

    _onFabSpeakTextClicked(): void {
        if(this.activeSelection) {
            this.speakActiveSelection();
        }
    };

}
